enum Routes {
  CHOOSE_PRODUCT = '/choose-product',
  ADDITIONAL_INFORMATION = '/additional-information',
  REVIEW_INFORMATION = '/review-information',
  PAYMENT = '/payment',
  CONFIRMATION = '/confirmation',
}

export default Routes
